'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .loader {\n    position: relative;\n    .spinner {\n      @keyframes spinner {\n        to {\n          transform: rotate(360deg);\n        }\n      }\n      &:before {\n        content: \'\';\n        box-sizing: border-box;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 70px;\n        height: 70px;\n        margin-top: -35px;\n        margin-left: -35px;\n        border-radius: 50%;\n        border-top: 2px solid #e3383a;\n        border-right: 2px solid transparent;\n        animation: spinner 0.6s linear infinite;\n      }\n    }\n  }\n'], ['\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  .loader {\n    position: relative;\n    .spinner {\n      @keyframes spinner {\n        to {\n          transform: rotate(360deg);\n        }\n      }\n      &:before {\n        content: \'\';\n        box-sizing: border-box;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 70px;\n        height: 70px;\n        margin-top: -35px;\n        margin-left: -35px;\n        border-radius: 50%;\n        border-top: 2px solid #e3383a;\n        border-right: 2px solid transparent;\n        animation: spinner 0.6s linear infinite;\n      }\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SpinnerWrapper = _styledComponents2.default.div(_templateObject);

var Spinner = function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        SpinnerWrapper,
        null,
        _react2.default.createElement(
          'div',
          { className: 'loader' },
          _react2.default.createElement('div', { className: 'spinner' })
        )
      );
    }
  }]);

  return Spinner;
}(_react.Component);

exports.default = Spinner;

//# sourceMappingURL=Spinner.js.map